import View from "../framework/view";
import jQuery from "jquery";
import rrwebPlayer from "rrweb-player";
import Server from "../server";

const classname = "rrweb-view";

const server = Server.instance();

export class RrWebView extends View {

    readonly session: string;

    private events: any;

    constructor(session: string) {
        super(classname);
        this.session = session;
        this.init();
    }

    async init() {
        const urls = await server.rrweb(this.session);
        const promises = urls.map(url => fetch(url).then(response => response.json()));
        const events = await Promise.all(promises);
        this.events = events.flat();
        this.update();
    }

    render0() {

        const out = jQuery("<div>");

        if (! this.events) {
            out.addClass("loading").text("Loading web session...");
        }

        this.initElt(() => {

            const elt = this.elt()[0];

            if (! elt || ! this.events) {
                return;
            }

            new rrwebPlayer({
                target: elt,
                props: {
                    events: this.events,
                    tags: {
                        "url": "blue"
                    }
                }
            });
        });

        return out;
    }
}
